// extracted by mini-css-extract-plugin
export default {"partner":"styles_partner__CbG+M","addName":"styles_addName__fPrsZ","locations":"styles_locations__90CMn","input":"styles_input__Ve4eQ"};